module.exports = __webpack_public_path__ + "img/20200403144059499.b8caf186.png";